"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.dashboard.heading': 'Content Planning Center',
    'socialMediaPlan.dashboard.desc': 'Create content, select channels, plan publishing and track results — manually or with AI.',
};
